export class Tag {
    key: string;
    value: string;

    constructor(tag) {
        this.key = tag?.key;
        this.value = tag?.value;
    }
}
